import React from 'react';
import { Dialog, DialogContent, DialogContentText, Button, DialogActions } from '@mui/material';
import { Auth } from 'aws-amplify';
import HandshakeIcon from '@mui/icons-material/Handshake';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import remarkGfm from 'remark-gfm';
import { remarkExtendedTable, extendedTableHandlers } from 'remark-extended-table';
import { USER_CONSENT_ATTRIBUTE } from '../sections/ChatSection';
import LinkRenderer from './LinkRenderer';

const style = {
  consent: {
    backgroundColor: 'rgba(255, 255, 255, 0.30)',
    padding: '24px !important',
    textAlign: 'left',
  },
  consentText: {
    backgroundColor: '#E7E8EB',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  consentTextContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  consentIcon: {
    color: '#41484D',
    height: '24px',
    width: '24px',
    marginBottom: '16px',
  },
  consentTitle: {
    fontSize: '24px',
    fontWeight: '400',
    color: '#191C1E',
    marginTop: '0px',
    marginBottom: '16px',
  },
  consentContent: {
    fontSize: '14px',
    fontWeight: '400',
    color: '#41484D',
    margin: '0px',
  },
  consentActions: {
    backgroundColor: '#E7E8EB',
  },
  consentAction: {
    margin: '24px',
    color: '#00658F',
    fontSize: '14px',
    fontWeight: '500',
  },
};

const ConsentDialog = ({ user, handleClose, open, terms, chatTitle, setChatInputFocus, messageRef }) => {
  const handleAgree = async () => {
    user.attributes[USER_CONSENT_ATTRIBUTE] = 'true';
    handleClose();
    setChatInputFocus(messageRef);
    Auth.updateUserAttributes(user, {
      [USER_CONSENT_ATTRIBUTE]: 'true',
    });
  };
  return (
    <Dialog
      open={open}
      style={style.consent}
      PaperProps={{
        sx: {
          width: '565px',
          height: '580px',
          borderRadius: '28px',
          maxHeight: '75%',
          maxWidth: '90%',
        },
      }}
    >
      <DialogContent style={style.consentText}>
        <DialogContentText style={style.consentTextContent}>
          <HandshakeIcon style={style.consentIcon} />
          <p style={style.consentTitle}>Welcome to {chatTitle}</p>
          <div style={style.consentContent}>
            <ReactMarkdown
              className="markdown-inform"
              remarkPlugins={[remarkGfm, extendedTableHandlers, remarkExtendedTable]}
              breaks={true}
              components={{ a: LinkRenderer }}
            >
              {terms || 'Loading, please wait…'}
            </ReactMarkdown>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={style.consentActions}>
        <Button style={style.consentAction} onClick={handleAgree}>
          I Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConsentDialog;
